import { Component } from 'react';
import type { ReactNode, ErrorInfo } from 'react';
import { Box, Text } from '@nike/podium';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box padding={24} style={{ textAlign: 'center' }}>
          <Text font="title-3" as="h2">Something went wrong.</Text>
          <Text font="body-1" as="p">
            Please try refreshing the page. If the problem persists, contact support.
          </Text>
        </Box>
      );
    }

    return this.props.children;
  }
}
